import { TeamMembers } from './TeamMembers';

export class RPDisplayModel {
    roleName: string;
    roleDescription: string;
    teamMembersType: string;
    hasGroupApproved: boolean;
    teamMembers: TeamMembers[] = [];
}